import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mj_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const ROLE_LABELS = {
  admin: "Administrator",
  gudang: "Petugas Gudang",
  qc: "Petugas QC",
  manajer: "Manajer / Penyetuju",
};

export const STATUS_META = {
  DRAFT: { label: "DRAFT", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  MENUNGGU_PEMERIKSAAN: { label: "MENUNGGU PEMERIKSAAN", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  KARANTINA: { label: "KARANTINA", cls: "bg-yellow-100 text-yellow-800 border-yellow-400" },
  DITERIMA: { label: "DITERIMA", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  DITOLAK: { label: "DITOLAK", cls: "bg-red-100 text-red-700 border-red-300" },
  DIBATALKAN: { label: "DIBATALKAN", cls: "bg-slate-200 text-slate-500 border-slate-300" },
};

export const CATEGORY_LABELS = {
  bahan_baku_segar: "Bahan Baku Segar",
  bahan_baku_olahan_terkemas: "Bahan Baku Olahan Terkemas",
  bahan_kemasan: "Bahan Kemasan",
};

export function fmtDate(d) {
  if (!d) return "-";
  return d.length > 10 ? d.slice(0, 10) : d;
}
export function fmtDateTime(d) {
  if (!d) return "-";
  try { return new Date(d).toLocaleString("id-ID"); } catch { return d; }
}
